<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center">
    <h3>CRM</h3>
    <div class="d-flex gap-2">
      <p-button
        icon="pi pi-plus"
        label="Create Tour"
        class="primary-btn"
        (click)="showCreateTourDialog()"
      ></p-button>
      <p-button
        icon="pi pi-sliders-h"
        [label]="isLoadingStages ? 'Loading...' : 'Manage Stages'"
        severity="secondary"
        class="primary-btn"
        [disabled]="isLoadingStages"
        [loading]="isLoadingStages"
        (click)="openStageDialog()"
      ></p-button>
    </div>
  </div>

  <!-- Summary widgets -->
  <div class="crm-widgets mt-3">
    <div class="crm-widget">
      <span class="widget-label">All Tours</span>
      <span class="widget-count">{{ summary.total }}</span>
    </div>
    <div class="crm-widget needs-attention">
      <span class="widget-label">Needs Attention</span>
      <span class="widget-count">{{ summary.needsAttention }}</span>
    </div>
    <div class="crm-widget waiting-on-lead">
      <span class="widget-label">Waiting on Lead</span>
      <span class="widget-count">{{ summary.waitingOnLead }}</span>
    </div>
    <div class="crm-widget scheduled">
      <span class="widget-label">Scheduled</span>
      <span class="widget-count">{{ summary.scheduled }}</span>
    </div>
    <div class="crm-widget ready-to-apply">
      <span class="widget-label">Ready to Apply</span>
      <span class="widget-count">{{ summary.readyToApply }}</span>
    </div>
    <div class="crm-widget signed-elsewhere">
      <span class="widget-label">Signed Elsewhere</span>
      <span class="widget-count">{{ summary.signedElsewhere }}</span>
    </div>
    <div class="crm-widget stalled">
      <span class="widget-label">Stalled</span>
      <span class="widget-count">{{ summary.stalled }}</span>
    </div>
    <div class="crm-widget unresponsive">
      <span class="widget-label">Unresponsive</span>
      <span class="widget-count">{{ summary.unresponsive }}</span>
    </div>
  </div>

  <!-- Filter chips -->
  <div class="crm-filter-chips mt-3">
    <button
      *ngFor="let chip of filterChips"
      class="filter-chip"
      [class.active]="activeFilter === chip.key"
      [style.--chip-color]="chip.color"
      [pTooltip]="chip.tooltip"
      tooltipPosition="bottom"
      (click)="onChipClick(chip.key)"
    >
      {{ chip.label }}
      <span class="chip-count">{{ summary[chip.summaryKey] ?? 0 }}</span>
    </button>
  </div>

  <!-- Filter bar -->
  <div class="crm-filter-bar mt-3">
    <div class="filter-dropdowns">
      <div class="filter-search">
      <i class="pi pi-search filter-search-icon"></i>
      <input
        pInputText
        type="text"
        placeholder="Search by lead, phone, plan or resident..."
        [(ngModel)]="crmFilters.search"
        (ngModelChange)="onSearchInput()"
        class="filter-search-input"
      />
    </div>
      <p-dropdown
        [options]="planOptions"
        [(ngModel)]="crmFilters.planName"
        placeholder="All Plans"
        [showClear]="true"
        (onChange)="onDropdownChange()"
      ></p-dropdown>
      <p-dropdown
        [options]="residentOptions"
        [(ngModel)]="crmFilters.residentId"
        placeholder="All Residents"
        [showClear]="true"
        [filter]="true"
        filterPlaceholder="Search..."
        (onChange)="onDropdownChange()"
      ></p-dropdown>
      <p-dropdown
        [options]="tourStatusOptions"
        [(ngModel)]="crmFilters.tourStatusFilter"
        placeholder="Tour Status"
        [showClear]="true"
        (onChange)="onDropdownChange()"
      ></p-dropdown>
      <!-- <p-dropdown
        [options]="leadStageOptions"
        [(ngModel)]="crmFilters.leadStageKey"
        placeholder="Lead Stage"
        [showClear]="true"
        (onChange)="onDropdownChange()"
      ></p-dropdown> -->
      <p-dropdown
        [options]="followupStatusOptions"
        [(ngModel)]="crmFilters.followupStatusFilter"
        placeholder="Followup Status"
        [showClear]="true"
        (onChange)="onFollowupStatusDropdownChange()"
      ></p-dropdown>
    </div>
  </div>

  <div class="crm-listing p-4 mt-3 m-1">
    <p-table
      #dt
      [value]="groupedLeads"
      [loading]="isLoadingLeads"
      responsiveLayout="scroll"
      [expandedRowKeys]="expandedRows"
      dataKey="_id"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th pSortableColumn="customer_name">Lead <p-sortIcon field="customer_name"></p-sortIcon></th>
          <th pSortableColumn="phone_number">Phone <p-sortIcon field="phone_number"></p-sortIcon></th>
          <th pSortableColumn="plan_name">Plan Name <p-sortIcon field="plan_name"></p-sortIcon></th>
          <th>Resident</th>
          <th>Tour Status</th>
          <th>Lead Stage</th>
          <th>Followup Status</th>
          <th pSortableColumn="date">Date & Time <p-sortIcon field="date"></p-sortIcon></th>
          <th>Action</th>
        </tr>
      </ng-template>

      <!-- Parent row -->
      <ng-template pTemplate="body" let-lead let-expanded="expanded">
        <tr class="parent-row" [class.ai-needs-help-row]="lead.followupStatus === 'ai-needs-help'">
          <td>
            <p-button
              *ngIf="lead.children?.length"
              type="button"
              [pRowToggler]="lead"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              styleClass="p-button-text p-button-rounded p-button-sm expander-btn"
            ></p-button>
          </td>
          <td>{{ lead.customer_name || '-' }}</td>
          <td>{{ lead.phone_number || '-' }}</td>
          <td>{{ lead.plan_name || '-' }}</td>
          <td>{{ lead.user_name || 'To Be Assigned' }}</td>
          <td>
            <span class="status-badge" [ngClass]="tourStatus(lead).class">
              {{ tourStatus(lead).text }}
            </span>
          </td>
          <td>
            <ng-container *ngIf="getLeadStageChips(lead) as chips">
              <ng-container *ngIf="chips.length; else noStage">
                <span class="stage-chip" [style.background-color]="chips[0].color">{{ chips[0].stageName }}</span>
                <span
                  *ngIf="chips.length > 1"
                  class="stage-chip-more"
                  [pTooltip]="chipsTooltip(chips)"
                  tooltipPosition="top"
                >+{{ chips.length - 1 }} more</span>
              </ng-container>
            </ng-container>
            <ng-template #noStage><span>-</span></ng-template>
          </td>
          <td>{{ getFollowupStatusTitle(lead.followupStatus) }}</td>
          <td>
            {{ lead.date + ' ' + lead.time | timezoneDate:userInfo?.property?.timezone:'time' }}
            {{ lead.date + ' ' + lead.time | timezoneDate:userInfo?.property?.timezone:'date' }}
          </td>
          <td>
            <div class="d-flex align-items-center gap-2">
              <p-button class="icon-secondary-btn" icon="pi pi-eye" pTooltip="View Chat" (click)="onClickInfoButton(lead)"></p-button>
              <p-button class="icon-secondary-btn" icon="pi pi-pencil" pTooltip="Edit" (click)="openEditDialog(lead)"></p-button>
              <p-button
                *ngIf="lead.followupStatus === 'ai-needs-help'"
                class="icon-danger-btn"
                icon="pi pi-comments"
                pTooltip="View AI conversation"
                (click)="openAiHelpDialog(lead)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Expanded child rows -->
      <ng-template pTemplate="rowexpansion" let-lead>
        <tr *ngFor="let child of lead.children" class="child-row" [class.ai-needs-help-row]="child.followupStatus === 'ai-needs-help'">
          <td></td>
          <td>{{ child.customer_name || '-' }}</td>
          <td>{{ child.phone_number || '-' }}</td>
          <td>{{ child.plan_name || '-' }}</td>
          <td>{{ child.user_name || 'To Be Assigned' }}</td>
          <td>
            <span class="status-badge" [ngClass]="tourStatus(child).class">
              {{ tourStatus(child).text }}
            </span>
          </td>
          <td>
            <ng-container *ngIf="getLeadStageChips(child) as chips">
              <ng-container *ngIf="chips.length; else noStageChild">
                <span class="stage-chip" [style.background-color]="chips[0].color">{{ chips[0].stageName }}</span>
                <span
                  *ngIf="chips.length > 1"
                  class="stage-chip-more"
                  [pTooltip]="chipsTooltip(chips)"
                  tooltipPosition="top"
                >+{{ chips.length - 1 }} more</span>
              </ng-container>
            </ng-container>
            <ng-template #noStageChild><span>-</span></ng-template>
          </td>
          <td>{{ getFollowupStatusTitle(child.followupStatus) }}</td>
          <td>
            {{ child.date + ' ' + child.time | timezoneDate:userInfo?.property?.timezone:'time' }}
            {{ child.date + ' ' + child.time | timezoneDate:userInfo?.property?.timezone:'date' }}
          </td>
          <td>
            <div class="d-flex align-items-center gap-2">
              <p-button class="icon-secondary-btn" icon="pi pi-eye" pTooltip="View Chat" (click)="onClickInfoButton(child)"></p-button>
              <p-button class="icon-secondary-btn" icon="pi pi-pencil" pTooltip="Edit" (click)="openEditDialog(child)"></p-button>
              <p-button
                *ngIf="child.followupStatus === 'ai-needs-help'"
                class="icon-danger-btn"
                icon="pi pi-comments"
                pTooltip="View AI conversation"
                (click)="openAiHelpDialog(child)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<app-message-conversation
  *ngIf="isChatOpen"
  [isSystemConversation]="isChatSystemConversation"
  [isLoading]="isChatLoading"
  [contactInfo]="selectedTour"
  [userType]="userInfo?.user_type"
  [property]="userInfo?.property?.name"
  [conversations]="selectedTour?.messages"
  (fetchConversation)="fetchSpecificConversationNew($event)"
  (close)="isChatOpen = false"
></app-message-conversation>

<!-- Create Tour Dialog -->
<p-dialog *ngIf="createTourVisible" header="Create Tour" [modal]="true" [(visible)]="createTourVisible"
  position="right" [style]="{ width: '35%' }" draggable="false">
  <app-create-tours *ngIf="createTourVisible" buttonLabel="Create" [planNames]="planNames"
    [tourData]="null" (closeDialog)="onCreateTourClose()"></app-create-tours>
</p-dialog>

<!-- Manage Lead Stages Dialog -->
<p-dialog
  header="Manage Lead Stages"
  [modal]="true"
  [(visible)]="showStageDialog"
  [style]="{ width: '580px' }"
  draggable="false"
>
  <div class="stage-dialog-body">
    <p class="stage-dialog-section-label">Existing stages (grouped by tour status)</p>

    <div class="stage-groups">
      <div class="stage-group" *ngFor="let group of groupedEditableStages">
        <span class="stage-group-key">{{ group.statusKey }}</span>
        <div class="stage-group-items">
          <div class="stage-item" *ngFor="let stage of group.stages">
            <span
              class="stage-chip-tag"
              [style.background]="stage.color + '22'"
              [style.border-color]="stage.color"
              [style.color]="stage.color"
            >
              <span class="stage-chip-dot" [style.background]="stage.color"></span>
              {{ stage.stageName }}
              <i
                *ngIf="stage.isSystem"
                class="pi pi-star-fill stage-item-star"
                pTooltip="System default"
              ></i>
              <span
                *ngIf="!stage.isSystem"
                class="stage-item-remove"
                (click)="removeEditableStage(group.statusKey, stage.stageName)"
              >×</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <hr class="stage-dialog-divider" />

    <p class="stage-dialog-section-label">Add a custom stage</p>

    <div class="stage-add-form">
      <input
        pInputText
        type="text"
        class="stage-name-field"
        [(ngModel)]="newStageName"
        (keydown.enter)="addCustomStage()"
        placeholder="Stage name — press Enter to add"
      />

      <label class="stage-field-label">Map to tour status</label>
      <p-dropdown
        [options]="stageTourStatusOptions"
        [(ngModel)]="newStageTourStatus"
        placeholder="Select tour status..."
        [showClear]="false"
        styleClass="stage-status-dropdown"
        appendTo="body"
      ></p-dropdown>
      <small class="stage-field-hint">This stage will appear for leads with the selected tour status.</small>

      <label class="stage-field-label">Pick a color</label>
      <div class="stage-color-row">
        <span
          class="stage-color-swatch"
          *ngFor="let c of stageColorSwatches"
          [style.background]="c"
          [class.selected]="newStageColor === c"
          (click)="newStageColor = c"
        ></span>
        <p-colorPicker
          [(ngModel)]="newStageColorHex"
          (onChange)="onColorPickerChange($event)"
          appendTo="body"
        ></p-colorPicker>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
      <p-button
        label="Close"
        severity="secondary"
        class="secondary-btn"
        (click)="showStageDialog = false"
      ></p-button>
      <p-button
        label="Save Changes"
        class="primary-btn"
        [loading]="isSavingStages"
        (click)="saveStages()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="AI Needs Help — Conversation"
  [modal]="true"
  [(visible)]="showAiHelpDialog"
  [style]="{ width: '560px' }"
  draggable="false"
>
  <div class="ai-help-dialog-body" *ngIf="aiHelpLead">
    <div class="ai-help-lead-info">
      <span class="ai-help-lead-name">{{ aiHelpLead.customer_name || '-' }}</span>
      <span class="ai-help-lead-phone">{{ aiHelpLead.phone_number || '' }}</span>
    </div>

    <div class="ai-help-message human">
      <div class="ai-help-bubble-label">Lead</div>
      <div class="ai-help-bubble">{{ aiHelpLead.aiNeedsHelpMessage || 'Message not available' }}</div>
    </div>

    <div class="ai-help-message ai">
      <div class="ai-help-bubble-label">AI Response</div>
      <div class="ai-help-bubble">{{ aiHelpLead.aiNeedsHelpResponse || 'Response not available' }}</div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" severity="secondary" (click)="showAiHelpDialog = false"></p-button>
  </ng-template>
</p-dialog>

<!-- Edit Followup Status Dialog -->
<p-dialog
  header="Edit Followup Status"
  [modal]="true"
  [(visible)]="showEditDialog"
  [style]="{ width: '440px' }"
  draggable="false"
>
  <div class="edit-status-dialog-body" *ngIf="editLead">
    <div class="edit-status-lead-info mb-3">
      <span class="fw-semibold">{{ editLead.customer_name || '-' }}</span>
      <span class="text-muted ms-2">{{ editLead.phone_number || '' }}</span>
    </div>

    <div class="mb-3">
      <label class="form-label">Followup Status</label>
      <p-dropdown
        [options]="followupStatusOptions"
        [(ngModel)]="editFollowupStatus"
        placeholder="Select status"
        [style]="{ width: '100%' }"
        optionLabel="label"
        optionValue="value"
      ></p-dropdown>
    </div>

    <div class="mb-3" *ngIf="editLeadStageChips.length">
      <label class="form-label">Lead Stage</label>
      <div class="edit-stage-chips">
        <span
          *ngFor="let chip of editLeadStageChips"
          class="edit-stage-chip"
          [class.selected]="chip.selected"
          [style.--chip-color]="chip.color"
          (click)="toggleEditLeadStage(chip.stageName)"
        >
          <span class="edit-stage-chip-dot" [style.background]="chip.selected ? '#fff' : chip.color"></span>
          {{ chip.stageName }}
        </span>
      </div>
    </div>

    <div class="form-check mt-3">
      <input
        class="form-check-input"
        type="checkbox"
        id="manualStatusLockCheck"
        [(ngModel)]="editManualStatusLock"
      />
      <label class="form-check-label" for="manualStatusLockCheck">
        Avoid auto-update
      </label>
      <div class="form-text">When checked, automated processes and cron jobs will not change this followup's status.</div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2"> 
    <p-button label="Cancel" class="secondary-btn" severity="secondary" (click)="showEditDialog = false"></p-button>
    <p-button
      label="Save"
      class="primary-btn"
      [loading]="isSavingStatus"
      [disabled]="!editFollowupStatus"
      (click)="saveFollowupStatus()"
    ></p-button>
    </div>

  </ng-template>
</p-dialog>

<p-toast></p-toast>
